/**
 * ParallaxPortrait — wraps a child with scroll-driven translateY parallax.
 *
 * - Triggered by scroll position of the inner ref
 * - Disabled on touch + reduced-motion
 *
 *   <ParallaxPortrait strength={-60}>
 *     <PortraitWithBlob />
 *   </ParallaxPortrait>
 */
import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";
import useIsFinePointer from "@/lib/useIsFinePointer";

export const ParallaxPortrait = ({
  children,
  strength = -60,
  className,
}) => {
  const fine = useIsFinePointer();
  const reduced = usePreferStaticUI();
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [strength * -0.5, strength]);

  const enabled = fine && !reduced;

  return (
    <motion.div
      ref={ref}
      className={className}
      style={enabled ? { y, willChange: "transform" } : undefined}
    >
      {children}
    </motion.div>
  );
};

export default ParallaxPortrait;
